const comscore = ({ path }) => {
  if (!window.udm_) {
    return
  }

  path = path === '/' ? 'splash' : path.replace(/^\//, '').replace(/\//g, '.')

  const params = {
    c1: 2,
    c2: 17827132,
    ns_site: 'po-totaal',
    name: `avrotrosportal.pip.programmas-sites.gouden-radioring.${path}`,
    potag1: 'avrotrosportal',
    potag2: 'goudenradioring',
    potag3: 'avrotros',
    potag4: 'avrotros',
    potag5: 'omroepportal',
    potag6: 'geen',
    potag7: 'geen',
    potag8: 'site',
    potag9: 'site'
  }

  const protocol = 'http' + (document.location.href.charAt(4) === 's' ? 's://sb' : '://b')
  const query = Object.keys(params)
    .map(key => `${key}=${params[key]}`)
    .join('&')

  window.udm_(protocol + '.scorecardresearch.com/p?' + query)
}

export default comscore



// WEBPACK FOOTER //
// ./src/router/comscore.js